import { render, staticRenderFns } from "./MessageTemplatesForEmail.vue?vue&type=template&id=f4a8c040&scoped=true"
import script from "./MessageTemplatesForEmail.vue?vue&type=script&lang=js"
export * from "./MessageTemplatesForEmail.vue?vue&type=script&lang=js"
import style0 from "./MessageTemplatesForEmail.vue?vue&type=style&index=0&id=f4a8c040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a8c040",
  null
  
)

export default component.exports